import { PackagingRegistration } from "../../Registry/packagingRegistry";

import BuildServerPackagingInstruction from "./BuildServerPackagingInstruction";
import ManualPackagingInstruction from "./ManualPackagingInstruction";
import CommandLinePackagingInstruction from "./CommandLinePackagingInstruction";

export const NetCorePackagingRegistration: PackagingRegistration = {
    displayOrder: 200,
    instructions: [
        BuildServerPackagingInstruction,
        ManualPackagingInstruction,
        CommandLinePackagingInstruction
    ],
    name: "ASP.NET Core",
    id: "AspNetCore"
};

export default NetCorePackagingRegistration;